import { useLocation } from '@reach/router';

/**
 * Hook to detect if the current page is a portfolio page
 * Portfolio pages have URLs that start with '/portfolio/'
 */
export default function useIsPortfolio(): boolean {
  const location = useLocation();

  // Check if the current pathname starts with '/portfolio/'
  return location.pathname.startsWith('/portfolio/');
}
